import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    cta: 'Unblock PIN',
    errorMessage: 'Oops! There was an unknown error.',
    subtitle: 'Your card was used with the wrong PIN 3 times in a row.',
    successMessage: 'The PIN was successfully unblocked.',
    title: 'Your PIN was blocked',
  },
  fr: {
    cancel: 'Annuler',
    cta: 'Débloquer le code',
    errorMessage: 'Oups\u00a0! Une erreur inconnue est survenue.',
    subtitle:
      'Votre carte bancaire a été utilisée avec le mauvais code trois fois de suite.',
    successMessage: 'Le code a bien été débloqué.',
    title: 'Votre code a été bloqué',
  },
});

export default locales;
